import React from 'react';
import { PageHeader } from '@ant-design/pro-layout';
import { renderBreadcrumb } from './buildBreadcrumb';

const Breadcrumbs = ( { crumbs } ) => (
    <PageHeader breadcrumb={ renderBreadcrumb( crumbs ) } />
);

export default Breadcrumbs;
